import { render, staticRenderFns } from "./vulnerability_list.vue?vue&type=template&id=5bd7fec6&"
import script from "./vulnerability_list.vue?vue&type=script&lang=js&"
export * from "./vulnerability_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports